import AxiosJob from '@/services/api/job/axios_job'

export default {
  createLaneExecutor: (data) => {
    return AxiosJob.post('lane-executor', data)
  },

  updateLaneExecutor: (laneExecutorId, data) => {
    return AxiosJob.put(`lane-executor/${laneExecutorId}`, data)
  },

  getLaneExecutorsFromLane: (laneId) => {
    return AxiosJob.get(`lane-executor/lane/${laneId}`)
  },

  getLaneExecutor: (laneExecutorId) => {
    return AxiosJob.get(`lane-executor/${laneExecutorId}`)
  },

  deleteLaneExecutor: (laneExecutorId, params) => {
    return AxiosJob.delete(`lane-executor/${laneExecutorId}`, { params })
  },

  getLaneExecutorsByUser: () => {
    return AxiosJob.get(`lane-executor/user`)
  },
}
